export enum LicenseReportFormType {
  NoForm = 0,
  OnShowsShown = 1,
  OnEvents = 2,
  OnAudioVisual = 3,
  WithDataFile = 4,
}
